module.exports = __webpack_public_path__ + "img/app_bg.542f69e4.png";